import React, { lazy, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import AuthLayout from '../container/profile/authentication/Index';
// import ForgotPassword from '../container/profile/authentication/overview/ForgotPassword';
// import SignUp from '../container/profile/authentication/overview/Signup';
// import SignUp from '../container/pages/signupPage';

const Login = lazy(() => import('../container/profile/authentication/overview/SignIn'));
const ForgotPassword = lazy(() => import('../container/profile/authentication/overview/ForgotPassword'));
const ResetPassword = lazy(() => import('../container/profile/authentication/overview/ResetPassword'));
const SignUp = lazy(() => import('../container/profile/authentication/overview/Signup'));
const OTPVerification = lazy(() => import('../container/profile/authentication/overview/OTPVerification'));

const AuthRoot = () => {
  const navigate = useNavigate();

  useEffect(() => navigate('/'));
};

const FrontendRoutes = React.memo(() => {
  return (
    <Routes>
      <Route index element={<Login />} />
      <Route path="*" element={<AuthRoot />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="reset-password" element={<ResetPassword />} />
      <Route path="register" element={<SignUp />} />
      <Route path="otp-verification" element={<OTPVerification />} />
    </Routes>
  );
});

export default AuthLayout(FrontendRoutes);
